/* 🤖 this file was generated by svg-to-ts */
export const matIconJoinLeft: {
  name: 'join-left';
  data: string;
} = {
  name: 'join-left',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><ellipse cx="12" cy="12" rx="3" ry="5.74"/><path d="M7.5 12c0-.97.23-4.16 3.03-6.5C9.75 5.19 8.9 5 8 5c-3.86 0-7 3.14-7 7s3.14 7 7 7c.9 0 1.75-.19 2.53-.5-2.8-2.34-3.03-5.53-3.03-6.5zM16 5c-.9 0-1.75.19-2.53.5.61.51 1.1 1.07 1.49 1.63.33-.08.68-.13 1.04-.13 2.76 0 5 2.24 5 5s-2.24 5-5 5c-.36 0-.71-.05-1.04-.13-.39.56-.88 1.12-1.49 1.63.78.31 1.63.5 2.53.5 3.86 0 7-3.14 7-7s-3.14-7-7-7z"/></svg>`
};
